import { Controller } from "stimulus";

export default class extends Controller {
  openWidget(e) {
    e.preventDefault();
    Calendly.initPopupWidget({ url: this.data.get("url") });
    return false;
  }
}
